import { useReducer } from 'react';

import { validations } from 'state/validation';
import { formReducer, reset, onBlur, setValue, setIsValid } from 'state/form-reducer';

export const useForm = () => {
  const [state, dispatch] = useReducer(formReducer, {});
  return {
    state,
    setValue: (name, value) => {
      const isValid = validations[name](value);
      dispatch(setValue(name, value, isValid));
    },
    onBlur: (name) => dispatch(onBlur(name)),
    reset: () => dispatch(reset()),
    fieldsAreValid: (fields) =>
      fields.every((fieldName) => {
        const field = state[fieldName];
        const value = field?.value ?? '';
        const isValid = field && field.isValid && field.blurred;
        dispatch(setIsValid(fieldName, isValid));
        if (isValid === undefined) {
          fields.forEach((fieldName) => {
            const isValid = validations[fieldName](value);
            dispatch(setValue(fieldName, value, isValid));
            dispatch(onBlur(fieldName));
          });
        } else {
          return isValid;
        }
      })
  };
};
